import { appState } from "../../../utils/store";
import { getViewport, isViewportInitialized } from "./viewport.layer";
import { debounce } from "lodash-es";
import {
  handleWheelPluginOnMetaCtrlKey,
  pauseWheelPlugin,
  resumeWheelPlugin
} from "./zoomControl";
import { updateBackground } from "../background/background.utils";

const RESOLUTION_CHANGE_DELAY = 200;
const STEP_FLOW_LINE_TRIGGER_SCALE = 1;

/**
 * Callback for viewport's zoomed event, which helps in setting the
 * correct resolution for the text that works optimally for the
 * current zoom level.
 *
 * Debounce helps keeping the zoom smoother since change in resolution
 * has cascades into all Text objects on screen. If resolution changes
 * too frequently, it causes frame-drops.
 *
 * Also if the scale is more than STEP_FLOW_LINE_TRIGGER_SCALE, we need to show the step flow lines
 * so update the appState.shouldShowStepFlowLines
 */
export const updateResolution = debounce(() => {
  // Edge case if viewport was unmounted
  // before the debounce was called
  if (!isViewportInitialized()) return;
  const currentScale = getViewport().scale.x;
  // temp adding 0.5 to reduce blurryness of the text
  const textResolution = 0.5 + currentScale * window.devicePixelRatio;
  if (appState.resolution !== textResolution) {
    appState.resolution = textResolution;
    const shouldShowStepFlowLines = currentScale > STEP_FLOW_LINE_TRIGGER_SCALE;
    if (appState.shouldShowStepFlowLines !== shouldShowStepFlowLines) {
      appState.shouldShowStepFlowLines = shouldShowStepFlowLines;
    }
  }
}, RESOLUTION_CHANGE_DELAY);

export const loadViewportEventHandlers = () => {
  const viewport = getViewport();
  updateResolution();
  /**
   * Add viewport events to redraw background
   */
  viewport.on("zoomed", updateBackground);
  viewport.on("zoomed-end", updateResolution);
  viewport.on("moved", updateBackground);
  viewport.on("pinch-start", resumeWheelPlugin);
  viewport.on("pinch-end", pauseWheelPlugin);
  viewport.on("wheel", handleWheelPluginOnMetaCtrlKey);
};

export const unloadViewportEventHandlers = () => {
  const viewport = getViewport();
  /**
   * Add viewport events to redraw background
   */
  viewport.off("zoomed", updateBackground);
  viewport.off("zoomed-end", updateResolution);
  viewport.off("moved", updateBackground);
  viewport.off("pinch-start", resumeWheelPlugin);
  viewport.off("pinch-end", pauseWheelPlugin);
  viewport.off("wheel", handleWheelPluginOnMetaCtrlKey);
};
